'use strict';

/* $ */
/* _ */
/* Backbone */
/* global Marionette */

import toPrice from '../../../utils/price';

/**
 * Класс для вывода данных из калькулятора
 * В зависимости от настроек умеет выводить цены либо числа (со знаком ≈)
 *     Параметры:
 *         field - поле модели, которое выводим
 *         field_publ_name - название поля для показа
 *         unit - единица измерения
 *         value_as - тип вывода (price|approx)
 */
class CalculatorInfo extends Marionette.View {
    getTemplate() {
        return '#tpl-calculator__info';
    }
    className() {
        return 'calculator-info';
    }
    modelEvents() {
        let self = this;
        let value = self.getOption('field');
        let events = {};
        events['change:'+value] = 'render';

        return events;
    }
    templateContext(){
        let self = this;

        let value = self.model.get(self.getOption('field')) || 0;
        let class_value = '';
        let unit = self.model.get('unit') || self.getOption('unit') || '';
        switch(self.getOption('value_as')){
        case 'price':
            value = toPrice({
                price: value,
                kop: true,
                sign: 'р'
            });
            class_value = ' price';
            unit = '';
            break;
        case 'approx':
            if(value > 0){
                value = '≈ ' + Math.ceil(value * 1000) / 1000;
            }
        }

        if(unit){
            value+=' '+unit;
        }

        return {
            name: self.getOption('field_publ_name'),
            value: value,
            class_value: class_value
        };
    }
}

export {
    CalculatorInfo,
};

